import { combineReducers } from 'redux';
import { formReducer } from './FormReducer';
import { alertReducer } from './AlertReducer';
import { stepReducer } from './StepReducer';
import { userReducer } from './UserReducer';
import { lidZoekenReducer } from './LidZoekenReducer';
import { extraStepReducer } from './ExtraStepReducer';
import { renderFormTriggerReducer } from './RenderFormTriggerReducer';

export default combineReducers({
  forms: formReducer,
  alerts: alertReducer,
  steps: stepReducer,
  extraSteps: extraStepReducer,
  user: userReducer,
  lidZoeken: lidZoekenReducer,
  renderFormTriggers: renderFormTriggerReducer
});